import { CALLING_COMPONENT } from 'navigation-components/config';
import { getParentWindow } from './window';
const TARGET_ORIGIN = '*';
const postDndMessage = ({
  postMessage = window.postMessage,
  message,
  origin = window.location.origin
}) => {
  postMessage(message, origin);
};
export const sendMessageToParent = message => {
  const parentWindow = getParentWindow();
  if (!parentWindow) return;
  postDndMessage({
    origin: TARGET_ORIGIN,
    postMessage: parentWindow.postMessage,
    message: Object.assign({}, message, {
      originComponent: CALLING_COMPONENT
    })
  });
};